import { render, staticRenderFns } from "./crmToolbar.vue?vue&type=template&id=0ec36424&scoped=true"
import script from "./crmToolbar.vue?vue&type=script&lang=js"
export * from "./crmToolbar.vue?vue&type=script&lang=js"
import style0 from "./crmToolbar.vue?vue&type=style&index=0&id=0ec36424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec36424",
  null
  
)

export default component.exports